enum SourceEnum {
  Map = "map",
  WorkOrders = "workorders",
  Vehicle = "vehicle",
  HwrcSite = "hwrcsite",
  DisposalSite = "disposalsite"
}

export { SourceEnum };
